import type { FC } from 'react';

interface ExpressBadgeProps {
  color: string;
}

export const ExpressBadge: FC<ExpressBadgeProps> = ({ color }) => {
  return (
    <div
      style={{
        background: 'transparent',
        color,
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10px',
        fontWeight: 'bold',
        border: `3px solid ${color}`,
        flexShrink: 0,
        animation:
          color === '#8B0000'
            ? 'pulse-critical 2s infinite'
            : color === '#FF0000'
              ? 'pulse-warning 3s infinite'
              : undefined,
      }}
    >
      E
    </div>
  );
};
